import React from 'react';
import {PropTypes} from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import {FormatString, ToString, InitTooltips} from './utils';

const tooltipTemplate = '<div class="{0}" role="tooltip"><div class="arrow"></div><div class="tooltip-inner text-pre-wrap"></div></div>';

let tooltipCounter = 0;
const DATA_ATTRIBUTE = 'simpletooltip';

let isTouchDevice = false;
function handleTouchEvent () {
    $('body').off('touchstart', handleTouchEvent);
    isTouchDevice = true;
}

$('body').on('touchstart', handleTouchEvent);

export class SimpleTooltip extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);

        tooltipCounter++;
        this._tooltipId = 'std-tooltip-' + tooltipCounter;
        this._tooltipSelector = `[data-${DATA_ATTRIBUTE}="${this._tooltipId}"]`;
        this.isTipVisible = false;
        this.$tooltip = null;

        this.handleTooltipShown = this.handleTooltipShown.bind(this);
        this.handleTooltipHidden = this.handleTooltipHidden.bind(this);
        this.bindTooltipEvents = this.bindTooltipEvents.bind(this);
        this.unbindTooltipEvents = this.unbindTooltipEvents.bind(this);

        this.getTooltip = this.getTooltip.bind(this);
        this.destroyTooltip = this.destroyTooltip.bind(this);
        this.getTooltipContent = this.getTooltipContent.bind(this);
        this.getTooltipTemplateClass = this.getTooltipTemplateClass.bind(this);
        this.getTooltipConfig = this.getTooltipConfig.bind(this);
        this.createTooltip = this.createTooltip.bind(this);

        this.isIgnoreEventTriggerEvent = this.isIgnoreEventTriggerEvent.bind(this);
    }

    isIgnoreEventTriggerEvent(e) {
        const result = 
            (e.type == 'mouseenter') &&
            this.props.ignoreHoverOnTouch &&
            isTouchDevice;

        return result;
    }

    getTooltip() {
        const self = this;

        if (Boolean(self.$tooltip) && !Boolean(self.$tooltip.data('bs.tooltip'))) {
            self.$tooltip = null;
        }

        return self.$tooltip;
    }

    getTooltipTemplateClass() {
        const self = this;
        let {theme, maxWidth, likePopover} = self.props;

        const result = ['tooltip'];
        
        if (Boolean(theme)) {
            result.push(`tooltip-${theme}`);
        }
        
        if (Boolean(maxWidth)) {
            result.push(`tooltip${self._tooltipId}-width`);
        }
        else {
            result.push('tooltip-fullwidth');
        }

        if (likePopover) {
            result.push('like-popover');
        }

        return result.join(' ');
    }

    getTooltipConfig() {
        const self = this;
        let {placement, showDelay, hideDelay, animation, isHtml, trigger} = self.props;

        const config = {
            'placement': placement,
            'boundary': 'window',
            'delay': {show: showDelay, hide: hideDelay},
            'html': isHtml,
            'template': FormatString(tooltipTemplate, self.getTooltipTemplateClass()),
            'animation': animation,
            'trigger': trigger,
        };

        return config;
    }

    getTooltipContent() {
        const {isHtml, title} = this.props;
        let result = null;

        var _title = title;

        if (typeof title === 'function') {
            _title = title();
        }

        if (Boolean(ToString(_title))) {
            if (isHtml && React.isValidElement(_title)) {
                result = ReactDOMServer.renderToStaticMarkup(_title);
            }
            else {
                result = ToString(_title);
            }
        }

        return result || '';
    }

    handleTooltipShown(e) {
        const self = this;
        self.isTipVisible = true;
        if (!self.props.visible) {
            const $tooltip = self.getTooltip();
            if (Boolean($tooltip)) {
                $tooltip.tooltip('hide');
            }
        }
    }

    handleTooltipHidden(e) {
        this.isTipVisible = false;
    }

    bindTooltipEvents() {
        const self = this;

        $('body')
            .on('shown.bs.tooltip', self._tooltipSelector, self.handleTooltipShown)
            .on('hidden.bs.tooltip', self._tooltipSelector, self.handleTooltipHidden);
    }

    unbindTooltipEvents() {
        const self = this;

        $('body')
            .off('shown.bs.tooltip', self._tooltipSelector, self.handleTooltipShown)
            .off('hidden.bs.tooltip', self._tooltipSelector, self.handleTooltipHidden);
    }

    createTooltip(showImmediately) {
        const self = this;

        if (!Boolean(self.getTooltip()) && self.props.visible) {
            InitTooltips();

            const config = self.getTooltipConfig();
            config.title = self.getTooltipContent();
            self.$tooltip = $(`[data-${DATA_ATTRIBUTE}="${self._tooltipId}"]`).tooltip(config);

            if (Boolean(showImmediately)) {
                self.$tooltip.tooltip('show');
            }
            else {
                self.$tooltip.tooltip('toggle');
            }

            self.bindTooltipEvents();
        }
    }

    destroyTooltip() {
        const self = this;

        const $tooltip = self.getTooltip();
        if (Boolean($tooltip)) {
            self.$tooltip = null;
            self.unbindTooltipEvents();
            $tooltip.tooltip('dispose');
        }
    }

    componentWillUnmount() {
        this.destroyTooltip();
    }

    componentDidUpdate(prevProps) {
        const self = this;
        const $tooltip = self.getTooltip();

        if (!self.props.visible) {
            self.destroyTooltip();
        }
        else if (Boolean($tooltip))
        {
            const props = self.props;
            const prevConfig = $tooltip.data('bs.tooltip').config;
            const config = self.getTooltipConfig();
            
            if (prevConfig.trigger != config.trigger) {
                console.error('SimpleTooltip does not support changing the "trigger" property');
            }
            // else if (prevConfig.template != config.template) {
            //     console.error('SimpleTooltip does not support changing the "template" property');
            // }

            let needRecreate = 
                (prevConfig.placement != config.placement) ||
                (prevConfig.boundary != config.boundary) ||
                (JSON.stringify(prevConfig.delay) != JSON.stringify(config.delay)) ||
                (prevConfig.html != config.html) ||
                (prevConfig.template != config.template) ||
                (prevConfig.animation != config.animation);

            let contentChanged = false;

            if ((prevProps.isHtml != props.isHtml) || (prevProps.title != props.title) || (typeof props.title === 'function')) {
                const title = self.getTooltipContent();
                if (title != prevConfig.title) {
                    contentChanged = true;
                    needRecreate = true;
                    config.title = title;
                }
            }

            const isTipVisible = self.isTipVisible; 
            if (needRecreate) {
                const needClassUpdate = prevConfig.template != config.template;
                Object.assign(prevConfig, config);
                
                if (needClassUpdate) {
                    const $tip = $($tooltip.data('bs.tooltip').tip);
                    const newClasses = $tip.attr('class')
                        .split(/\s+/)
                        .filter(s => !s.match(/^(tooltip|tooltip-(.*)|like-popover)$/))
                        .join(' ') + 
                        ' ' + 
                        self.getTooltipTemplateClass();
                    
                    $tip.attr('class', newClasses);
                }

                if (contentChanged && isTipVisible && props.visible) {
                    $tooltip.tooltip('setContent').tooltip('show');
                }
            }
            else if (isTipVisible && !props.visible) {
                $tooltip.tooltip('hide');
            }
        }
    }

    render() {
        const self = this;
        let {trigger, maxWidth, children, disabledOnTouch} = self.props;

        if (disabledOnTouch && isTouchDevice) {
            return children;
        }

        if (!React.isValidElement(children)) {
            console.log('The children of the SimpleTooltip must be the React element');
            return children;
        }

        const result = [];

        if (typeof maxWidth === 'number') {
            maxWidth += 'px';
        }
        else {
            maxWidth = ToString(maxWidth);
        }

        if (Boolean(maxWidth)) {
            const tooltipWidthClass = `tooltip${self._tooltipId}-width`;
            result.push(<style key={tooltipWidthClass} dangerouslySetInnerHTML={{ __html: `.tooltip.${tooltipWidthClass} .tooltip-inner {max-width:${maxWidth};}` }} />);
        }

        const childrenProps = children.props;

        const mixinProps = {
            'key': `controlwithtooltip${self._tooltipId}`,
            'data-original-title': '', // to prevet add the empty title attribute
        };

        mixinProps[`data-${DATA_ATTRIBUTE}`] = self._tooltipId;

        if (!Boolean(self.getTooltip())) {
            const triggers = (trigger || '').split(' ');

            triggers.forEach(tr => {
                let eventName = '';
                switch (tr) {
                    case 'hover':
                        eventName = 'onMouseEnter';
                        break;
                    case 'focus':
                        eventName = 'onFocus';
                        break;
                    case 'click':
                        eventName = 'onClick';
                        break;
                }

                if (Boolean(eventName)) {
                    const eventHandler = childrenProps[eventName];

                    if (typeof eventHandler === 'function') {
                        mixinProps[eventName] = (e) => {
                            if (!self.isIgnoreEventTriggerEvent(e)) {
                                self.createTooltip(false);
                            }
                            eventHandler(e);
                        }
                    }
                    else {
                        mixinProps[eventName] = (e) => {
                            if (!self.isIgnoreEventTriggerEvent(e)) {
                                self.createTooltip(false);
                            }
                        }
                    }
                }
            });
        }

        result.push(React.cloneElement(children, mixinProps));

        return result;
    }
}
SimpleTooltip.propTypes = {
    placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'auto']).isRequired,
    trigger: PropTypes.string.isRequired,
    animation: PropTypes.bool,
    visible: PropTypes.bool,
    isHtml: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
    showDelay: PropTypes.number,
    hideDelay: PropTypes.number,
    theme: PropTypes.oneOf(['default', 'white', 'black', 'muted', 'black-50', 'white-50', 'success', 'warning', 'danger', 'primary', 'secondary', 'info', 'light', 'dark', 'hint']),
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    likePopover: PropTypes.bool,
    ignoreHoverOnTouch: PropTypes.bool,
    disabledOnTouch: PropTypes.bool
}
SimpleTooltip.defaultProps = {
    placement: 'bottom',
    trigger: 'hover focus',
    animation: true,
    visible: true,
    isHtml: false,
    showDelay: 300,
    hideDelay: 0,
    theme: 'default',
    maxWidth: '',
    likePopover: true,
    ignoreHoverOnTouch: false,
    disabledOnTouch: false
}
